import axios from "axios";
import {
  makeAutoObservable,
  action,
  observable,
  computed,
  runInAction,
} from "mobx";
import { get, eq } from "lodash";
import { API_HOST, RequestState } from "../constants";
import {
  clearSessionCookie,
  getSessionCookie,
  storeSessionCookie,
} from "../utils";
import { userStore } from "../stores";

export class LoginController {
  _userStore = userStore;

  loginMessage = "";
  loginRequestState = RequestState.IDLE;

  constructor() {
    makeAutoObservable(this, {
      loginMessage: observable,
      loginRequestState: observable,
      login: action,
      logout: action,
      register: action,
      getLoginMessage: computed,
      getLoginRequestState: computed,
    });
  }

  async login(username, password) {
    runInAction(() => {
      this.loginMessage = "";
    });

    const defaultLoginErrorMessage =
      "Something went wrong. Please try again later.";

    if (!username.length || !password.length) {
      runInAction(() => {
        this.loginMessage = "Username and Password are required.";
      });
      return;
    }

    runInAction(() => {
      this.loginRequestState = RequestState.REQUESTED;
    });

    try {
      const response = await axios.post(`${API_HOST}user/login`, {
        username,
        password,
      });

      if (eq(response.status, 200)) {
        const { data } = response;
        const userObj = get(data, "user", null);

        const authToken = get(data, "auth-token", null);
        storeSessionCookie(authToken);

        runInAction(() => {
          if (!eq(userObj, null)) {
            const newUserObj = JSON.parse(userObj);
            this._userStore.setUserObj(newUserObj);
          }
          this.loginMessage = "";
          this._userStore.setLoggedIn(true);
          window.location.href = "/app/home";
        });
      } else {
        runInAction(() => {
          this.loginMessage = get(
            response,
            "data.message",
            defaultLoginErrorMessage
          );
        });
      }
    } catch (error) {
      console.log("Error loggin in", error);

      runInAction(() => {
        this.loginMessage = get(
          error,
          "response.data.error",
          defaultLoginErrorMessage
        );
      });
    }

    runInAction(() => {
      this.loginRequestState = RequestState.RECEIVED;
    });
  }

  async logout() {
    try {
      const response = await axios.post(
        `${API_HOST}user/logout`,
        {},
        {
          headers: {
            Authorization: await getSessionCookie(),
          },
        }
      );

      const { data } = response;

      console.log(data.message);
    } catch (error) {
      console.log("Error logging out", error.response.data.error);
    }

    runInAction(() => {
      this._userStore.setUserObj(null);
      this._userStore.setLoggedIn(false);
      clearSessionCookie();
    });
  }

  get getLoginMessage() {
    return this.loginMessage;
  }

  get getLoginRequestState() {
    return this.loginRequestState;
  }
}

export default LoginController;
